var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "org-tree-select" },
    [
      _c(
        "div",
        { staticClass: "org-tree-toolbar" },
        [
          _c("el-input", {
            attrs: {
              size: "mini",
              placeholder: "输入组织名称过滤",
              "prefix-icon": "el-icon-search",
              clearable: ""
            },
            on: { input: _vm.onFilter, clear: _vm.onFilter },
            model: {
              value: _vm.filterText,
              callback: function($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "org-tree-actions" },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.onMultiSelectChange },
                  model: {
                    value: _vm.multiSelect,
                    callback: function($$v) {
                      _vm.multiSelect = $$v
                    },
                    expression: "multiSelect"
                  }
                },
                [_vm._v("多选")]
              ),
              _vm._v(" "),
              _c(
                "el-checkbox",
                {
                  staticClass: "org-tree-include-children",
                  on: { change: _vm.onIncludeChildrenChange },
                  model: {
                    value: _vm.includeChildren,
                    callback: function($$v) {
                      _vm.includeChildren = $$v
                    },
                    expression: "includeChildren"
                  }
                },
                [_vm._v("含下级")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vxe-table",
        {
          ref: "orgTable",
          staticClass: "org-tree-table",
          attrs: {
            height: "100%",
            data: _vm.treeData,
            "tree-config": _vm.treeConfig,
            "checkbox-config": _vm.checkboxConfig,
            "show-header": false,
            loading: _vm.loading
          },
          on: {
            "cell-click": _vm.onCellClick,
            "checkbox-change": _vm.onCheckboxChange,
            "checkbox-all": _vm.onCheckboxAll
          }
        },
        [
          _c("vxe-column", {
            attrs: { type: "checkbox", width: "40", align: "center" }
          }),
          _vm._v(" "),
          _c("vxe-column", {
            attrs: { "tree-node": "", "min-width": "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "org-node-name",
                        class: {
                          "is-active":
                            "" + row.OrganizationId === "" + _vm.currentId
                        }
                      },
                      [_vm._v(_vm._s(row.OrganizationName))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62bbd93e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62bbd93e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrgTreeSelect.vue
// module id = null
// module chunks = 